import Main from '@/Shared/Layouts/Main'
import NotificationSettings from '@/Pages/Settings/Notifications'

export default function Settings() {
  return <NotificationSettings standAlone />
}

Settings.layout = (page) => <Main title="Update your preferences" children={page} standAlone />
